// extracted by mini-css-extract-plugin
export default {"containerAbout":"About_containerAbout__Yhqo1","sobre":"About_sobre__VtmGG"};